package com.happyukrainian.revision.kweb.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.happyukrainian.revision.kweb.components.PageContainer
import com.happyukrainian.revision.kweb.pages.routes.SubjectRoute
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.vh
import practicetest.Subject
import repositories.HttpClientSubjectRepository

enum class Screen {
    SubjectSelection,
    TopicSelection,
    MaterialSelection,
    FlashcardGame
}


@Page
@Composable
fun HomePage() {
    val ctx = rememberPageContext()
    val subjectRepository = HttpClientSubjectRepository()

    var subjects by remember { mutableStateOf<List<Subject>>(emptyList()) }

    var inError by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        subjectRepository.subjects()
            .onSuccess { subjects = it.subjects }
            .onFailure { inError = true }
    }

    PageContainer(modifier = Modifier.minHeight(100.vh)) {
        SubjectRoute(
            subjects = subjects,
            onSubjectSelected = { subject ->
                ctx.router.navigateTo("subject/${subject.key}/topics")
            }
        )
    }
}

